<script setup lang="ts">
import { ref, onMounted } from "vue";
import SearchSelect from "../../../../components/ui/form/SearchSelect.vue";
import { useFormValidation } from "../../../../composables/useFormValidation";
import { api } from "../../../../api/Api";
import Toast from "../../../../services/Toast";
import MessageBox from "../../../../services/MessageBox";
import ModalFormComponent from "../../../../components/ui/common/ModalFormComponent.vue";
import DocumentHeader from "../../../../components/ui/Templates/DocumentHeader.vue";
import DocumentFooter from "../../../../components/ui/Templates/DocumentFooter.vue";
import Buttons from "../../../../components/ui/form/Buttons.vue";
import FileUpload from "../../../../components/ui/form/FileUpload.vue";
import * as XLSX from "xlsx";
import { TableField } from "../../../../components/table/table";
import IconComponent from "../../../../components/ui/common/IconComponent.vue";

const props = defineProps<{
  endPoint: string;
}>();

interface matchField {
  field_name: string;
  caption: string;
  requried: boolean;
  mapped?: string;
}

interface excelFields {
  id: string;
  name: string;
}

const {
  validateForm,
} = useFormValidation({
  price_lists_id: "",
  warehouses_id: "",
  currencys_id: "",
  exchange_rate: 1,
  outlets_id: "",
});
//setFieldRules("currencys_id", [required("Select Currency")]);
//setFieldRules("exchange_rate", [required("Select Exchange Rate")]);

const matchFields = ref<matchField[]>([
  { field_name: "name", caption: "Name", requried: true, mapped: "" },
  { field_name: "customer_type", caption: "Custoemr Type", requried: true, mapped: "" },
  { field_name: "tax_identification_no", caption: "Tax Identification No", requried: false, mapped: "" },
  { field_name: "mobile", caption: "Mobile", requried: true, mapped: "" },
  { field_name: "credit_term", caption: "Credit Term", requried: true, mapped: "" },
  { field_name: "credit_limit", caption: "Credit Limit", requried: true, mapped: "" },
  { field_name: "price_list", caption: "Price List", requried: true, mapped: "" },
  { field_name: "payment_type", caption: "Payment Type", requried: true, mapped: "" },
  { field_name: "state", caption: "State", requried: false, mapped: "" },
  { field_name: "city", caption: "City", requried: false, mapped: "" },
  {
    field_name: "receivable_account",
    caption: "To Receivable Account",
    requried: true,
    mapped: "",
  }
]);

const tableColumns = ref<TableField[]>([]);

const excelData = ref<any[][]>([]);
const colHeaders = ref<excelFields[]>([]);

const handleFileUpload = (files: any[]) => {
  console.log(files);
   const file = files[0];
  if (!file) return;

  const reader = new FileReader();
  reader.onload = (e) => {
    if (e.target && e.target.result) {
      const data = new Uint8Array(e.target.result as ArrayBuffer);
      const workbook = XLSX.read(data, { type: "array" });
      const sheetName = workbook.SheetNames[0]; // Get the first sheet name
      const sheet = workbook.Sheets[sheetName];
    let jsonData = XLSX.utils.sheet_to_json(sheet, { header: 1 }); // Convert sheet to JSON

    // Format date columns in the first row (headers)
    const dateColIndexes = (jsonData[0] as string[])
      .map((header: string, idx: number) =>
        header.toLowerCase().includes("date") ? idx : -1
      )
      .filter(idx => idx !== -1);

    // Format date values in each row (except header)
    jsonData = (jsonData as any[][]).map((row: any[], rowIdx: number) => {
      if (rowIdx === 0) return row;
      dateColIndexes.forEach(colIdx => {
        const val = row[colIdx];        
        if (val && !isNaN(Date.parse(val)) && typeof val !== "number") {
          // If already a valid date string, format it
          row[colIdx] = new Date(val).toISOString().slice(0, 10);
        } else if (typeof val === "number") {
          // Excel dates are numbers, convert using XLSX
          row[colIdx] = XLSX.SSF.format("yyyy-mm-dd", val);
        }
      });
      return row;
    });
    if (jsonData.length > 0) {
      const arr = (jsonData[0] as string[]).map(
        (text: string, index: number) => ({
        id: index.toString(),
        name: text,
        })
      );
      arr.forEach((element) => {
        colHeaders.value.push(element);
        tableColumns.value.push({
        name: element.name,
        caption: element.name,
        sortable: false,
        fieldType: element.name.toLowerCase().includes("date") ? "date" : "text",
        });
      });
      jsonData.splice(0, 1); // Remove the first row from data

      excelData.value = jsonData as any[][];
    }
    }
  };
  reader.readAsArrayBuffer(file);
};

const mappedHeaders = ref<matchField[]>([]);
const mappedData = ref<Array<{
  name: string;
  customer_type: string;
  customer_types_id: string;
  tax_identification_no: string;
  mobile: string;
  price_list: string;
  credit_limit: string;
  price_lists_id: string;
  credit_term: string;
  credit_terms_id: string;
  payment_type: string;
  payment_types_id: string;
  receivable_account: string;
  chart_of_accounts_id: string;
  state: string;
  states_id: string;
  countrys_id: string;
  city: string;
  citys_id: string;
  valid: boolean;
  import?: boolean;
  expanded?: boolean;
  error?: string;
}>>([]);
const handlePreview = async () => {
  mappedHeaders.value = [];
  mappedData.value = [];
  dbData.value = [];
  const failed =
    matchFields.value.filter(
      (field) => field.mapped === "" && field.requried === true
    ).length > 0;
  if (failed) {
    MessageBox.show(
      "Please map all required fields before previewing the data.",
      "error"
    );
    return;
  }

  if (!validateForm()) {
    return;
  }
  const match_fields = matchFields.value.filter((field) => field.mapped !== "");
  match_fields.forEach((field) => {
    mappedHeaders.value.push(field);
  });
  /*mappedHeaders.value.push({
    field_name: "customers_id",
    caption: "DB Customer",
    requried: true,
    mapped: mappedHeaders.value.length.toString(),
  });*/
  console.log(mappedHeaders.value);
  excelData.value.forEach((element) => {
    let d = {
      name: matchFields.value.find((field) => field.field_name === "name")
        ?.mapped
        ? element[
            Number(
              matchFields.value.find((field) => field.field_name === "name")
                ?.mapped
            )
          ]
        : "",
       customer_type: matchFields.value.find((field) => field.field_name === "customer_type")
        ?.mapped
        ? element[
            Number(
              matchFields.value.find((field) => field.field_name === "customer_type")
                ?.mapped
            )
          ]
        : "",
      tax_identification_no: matchFields.value.find(
        (field) => field.field_name === "tax_identification_no"
      )?.mapped
        ? element[
            Number(
              matchFields.value.find(
                (field) => field.field_name === "tax_identification_no"
              )?.mapped
            )
          ]
        : "",
        mobile: matchFields.value.find(
        (field) => field.field_name === "mobile"
      )?.mapped
        ? element[
            Number(
              matchFields.value.find(
                (field) => field.field_name === "mobile"
              )?.mapped
            )
          ]
        : "",
        price_list: matchFields.value.find(
        (field) => field.field_name === "price_list"
      )?.mapped
        ? element[
            Number(
              matchFields.value.find(
                (field) => field.field_name === "price_list"
              )?.mapped
            )
          ]
        : "",
        credit_limit: matchFields.value.find(
        (field) => field.field_name === "credit_limit"
      )?.mapped
        ? element[
            Number(
              matchFields.value.find(
                (field) => field.field_name === "credit_limit"
              )?.mapped
            )
          ]
        : "",
        credit_term: matchFields.value.find(
        (field) => field.field_name === "credit_term"
      )?.mapped
        ? element[
            Number(
              matchFields.value.find(
                (field) => field.field_name === "credit_term"
              )?.mapped
            )
          ]
        : "",
        receivable_account: matchFields.value.find(
        (field) => field.field_name === "receivable_account"
      )?.mapped
        ? element[
            Number(
              matchFields.value.find(
                (field) => field.field_name === "receivable_account"
              )?.mapped
            )
          ]
        : "",
        payment_type: matchFields.value.find(
        (field) => field.field_name === "payment_type"
      )?.mapped
        ? element[
            Number(
              matchFields.value.find(
                (field) => field.field_name === "payment_type"
              )?.mapped
            )
          ]
        : "",
        payment_types_id: "",
        state: matchFields.value.find(
        (field) => field.field_name === "state"
      )?.mapped
        ? element[
            Number(
              matchFields.value.find(
                (field) => field.field_name === "state"
              )?.mapped
            )
          ]
        : "",
        states_id: "",
        city: matchFields.value.find(
        (field) => field.field_name === "city"
      )?.mapped
        ? element[
            Number(
              matchFields.value.find(
                (field) => field.field_name === "city"
              )?.mapped
            )
          ]
        : "",
        citys_id: "",
        customer_types_id: "",
        price_lists_id: "",
        credit_terms_id: "",
        chart_of_accounts_id: "",
        countrys_id: "1",
      valid: true
    };
    mappedData.value.push(d);
  });

  
const uniqueCustomerTypes = Array.from(new Set(mappedData.value.map(d => d.customer_type).filter(Boolean)));
const uniquePriceLists = Array.from(new Set(mappedData.value.map(d => d.price_list).filter(Boolean)));
const uniqueChartOfAccounts = Array.from(new Set(mappedData.value.map(d => d.receivable_account).filter(Boolean)));
const uniqueCreditTerms = Array.from(new Set(mappedData.value.map(d => d.credit_term).filter(Boolean)));
const uniquePaymentTypes = Array.from(new Set(mappedData.value.map(d => d.payment_type).filter(Boolean)));
const uniquestates = Array.from(new Set(mappedData.value.map(d => d.state).filter(Boolean)));
const uniqueCitys = Array.from(new Set(mappedData.value.map(d => d.city).filter(Boolean)));


  const data = await getListData(uniqueCustomerTypes, uniquePriceLists, uniqueChartOfAccounts, uniqueCreditTerms, uniquePaymentTypes, uniquestates, uniqueCitys);
console.log('Data from API:', data);
mappedData.value.forEach((record) => {
  console.log('record before mapping:', record);
    const customer_type = data.customerTypes.find((v: any) => v.name.toLowerCase() === record.customer_type.toLowerCase());
    record.customer_types_id = customer_type ? customer_type.id : "";
    const credit_term = data.creditTerms.find((c: any) => c.name.toLowerCase() === record.credit_term.toLowerCase());
    record.credit_terms_id = credit_term ? credit_term.id : "";
    const price_list = data.priceLists.find((c: any) => c.name.toLowerCase() === record.price_list.toLowerCase());
    record.price_lists_id = price_list ? price_list.id : "";
    const account = data.chartOfAccounts.find((t: any) => t.name.toLowerCase() === record.receivable_account.toLowerCase());
    record.chart_of_accounts_id = account ? account.id : "";
    const payment_type = data.paymentTypes.find((t: any) => t.name.toLowerCase() === record.payment_type.toLowerCase());
    record.payment_types_id = payment_type ? payment_type.id : "";
    const state = data.states.find((t: any) => t.name.toLowerCase() === record.state?.toLowerCase());
    record.states_id = state ? state.id : "";
    const city = data.citys.find((t: any) => t.name.toLowerCase() === record.city?.toLowerCase());
    record.citys_id = city ? city.id : "";
});


mappedData.value.forEach((record) => {
    dbData.value.push({
      name: record.name,
      customer_type: record.customer_type,
      customer_types_id: record.customer_types_id,
      tax_identification_no: record.tax_identification_no,
      mobile: record.mobile,
      price_list: record.price_list,
      credit_limit: record.credit_limit,
      price_lists_id: record.price_lists_id,
      credit_term: record.credit_term,
      credit_terms_id: record.credit_terms_id,
      payment_type: record.payment_type,
      payment_types_id: record.payment_types_id,
      receivable_account: record.receivable_account,
      accounts_receivable_id: record.chart_of_accounts_id,
        state: record.state,
        states_id: record.states_id,
        countrys_id: record.countrys_id,
        city: record.city,
        citys_id: record.citys_id,
      valid: record.valid,
    });
});


  //handleGetDataFromDb();

  console.log(mappedData.value);
  console.log(dbData.value);
};




const getListData = async (customerTypes: any, priceLists: any, chartOfAccounts: any, creditTerms: any, paymentTypes: any, states: any, citys: any) => {
// Call API and return the data
const response = await api.post(
    (props.endPoint.slice(-1) == "/" ? props.endPoint : props.endPoint + "/") + "data-for-import",
    {
        customerTypes: customerTypes,
        priceLists: priceLists,
        chartOfAccounts: chartOfAccounts,
        creditTerms: creditTerms,
        paymentTypes: paymentTypes,
        citys: citys,
        states: states,
    }
);
return response.data;
};

const getBgColor = (row: any) => {
  if (!row.name || row.name == "") {
    return "#ed8888";
  }
  if (!row.customer_types_id || row.customer_types_id == "") {
    return "#ed8888";
  }
  if (!row.mobile || row.mobile == "") {
    return "#ed8888";
  }
  if (!row.price_lists_id || row.price_lists_id == "") {
    return "#ed8888";
  }
  if (!row.credit_terms_id || row.credit_terms_id == "") {
    return "#ed8888";
  }
  if (!row.payment_types_id || row.payment_types_id == "") {
    return "#ed8888";
  }
  if (!row.chart_of_accounts_id || row.chart_of_accounts_id == "") {
    return "#ed8888";
  }
  return "";
};

const validated = ref(false);
const handleValidate = () => {
  let valid = true;
  dbData.value.forEach((element, index) => {
    if (element.name == "") {
      valid = false;
      return false;
    }
    if (element.customer_types_id == "") {
      valid = false;
      return false;
    }
    if (element.mobile == "") {
      valid = false;
      return false;
    }
    if (element.price_lists_id == "") {
      valid = false;
      return false;
    }
    if (element.payment_types_id == "") {
      valid = false;
      return false;
    }
    if (element.credit_terms_id == "") {
      valid = false;
      return false;
    }
    if (element.chart_of_accounts_id == "") {
      valid = false;
      return false;
    }
    dbData.value[index].valid = valid;
    if (index == dbData.value.length - 1) {
      validated.value = valid;
      console.log('Validation result:', validated.value);
      console.log(dbData.value);
    }
  });
};


const handleImportPost = async () => {
  let param =dbData.value[importIndex.value]
  await api.post(
        (props.endPoint.slice(-1) == "/"
          ? props.endPoint
          : props.endPoint + "/") + "create",
          param
      ).then((response) => {
        if (response.success == true) {
          Toast.show(
            "Importing record " +
              (importIndex.value + 1) +
              " of " +
              dbData.value.length +
              " records",
            "info"
          );
          if (importIndex.value < dbData.value.length - 1) {
            importIndex.value++;
            handleImportPost();
          } else {
            Toast.show("All records imported successfully", "info");
            validated.value = false;
            dbData.value = [];
            mappedData.value = [];
          }
        } else {
          dbData.value[importIndex.value].import = false;
          dbData.value[importIndex.value].error = response.message || "Error importing record";
          if (importIndex.value < dbData.value.length - 1) {
              importIndex.value++;
              handleImportPost();
          }
          Toast.show(
            "Error importing record " +
              (importIndex.value + 1) +
              " of " +
              dbData.value.length +
              " records",
            "error"
          );
        }
      })
      .catch((error => {
        console.log(error);
         dbData.value[importIndex.value].import = false;
         dbData.value[importIndex.value].error = error.response.message || "Error importing record";
        Toast.show(
          "Error importing record " +
            (importIndex.value + 1) +
            " of " +
            dbData.value.length +
            " records",
          "error"
        );
      }));
};

const importIndex = ref(0);
const handleImport = async () => {
  
  dbData.value.forEach(async (element) => {
    element.import = true;
  });
  if (dbData.value.filter((record) => getBgColor(record) != "").length > 0) {
    MessageBox.show(
      "Please fix all invalid records before importing.",
      "error"
    );
    return;
  } else {
  console.log('start posting', dbData.value[0]);
  importIndex.value = 0;
  handleImportPost()
  }
};

interface DbRow {
 name: string;
  customer_type: string;
  customer_types_id: string;
  tax_identification_no: string;
  mobile: string;
  price_list: string;
  credit_limit: string;
  price_lists_id: string;
  credit_term: string;
  credit_terms_id: string;
  receivable_account: string;
  accounts_receivable_id: string;
  state: string;
  states_id: string;
    countrys_id: string;
    city: string;
    citys_id: string;
  valid: boolean;
  import?: boolean;
  expanded?: boolean;
  error?: string;
  [key: string]: any; // Add this to allow additional properties
}

const dbData = ref<DbRow[]>([]);
/*const handleGetDataFromDb = async () => {
  const response = await api.post(
    (props.endPoint.slice(-1) == "/" ? props.endPoint : props.endPoint + "/") +
      "map-excel",
    {
      data: mappedData.value,
      price_lists_id: fields.value.price_lists_id.value,
      warehouses_id: fields.value.warehouses_id.value,
      currencys_id: fields.value.currencys_id.value,
      exchange_rate: fields.value.exchange_rate.value,
    }
  );
  if (response.success == true) {
    dbData.value = response.data;
  }
};*/


onMounted(() => {});

</script>

<template>
  <ModalFormComponent width="100%" @close="$emit('close')">
    <template #header>
      <!-- Header -->
      <DocumentHeader
        title="Import Customers using Excel Files"
        end-point=""
        :readonly="true"
        :show-drop-down="false"
        @close="$emit('close')"
        :permissions="[]"
        :show-share-icons="false"
        :show-save-icon="false"
      >
        <template>
          <Buttons caption="Import" icon="Import" @click="$emit('import')" />
        </template>
      </DocumentHeader>
    </template>

    <template #form>
      <div class="grid grid-cols-5 gap-6 mb-8">
        <div>
          <FileUpload
            label="Excel File"
            accept=".xlsx, .xls"
            @upload-success="handleFileUpload"
            path=""
            :local="true"
          />
          <div class="grid grid-cols-2 gap-2 mt-2">
            <Buttons
              caption="Prepare Data"
              icon="ListChecks"
              @click="handlePreview"
              className="mt-2"
            />
            <Buttons
              caption="Validate"
              icon="ShieldCheck"
              v-if="dbData.length > 0"
              @click="handleValidate"
              className="mt-2"
            />

            <Buttons
              caption="Import"
              icon="Import"
              class="col-span-2"
              type="info"
              v-if="validated"
              @click="handleImport"
              className="mt-2"
            />
          </div>
        </div>
        <div class="col-span-4 grid grid-cols-5 gap-1">
          <div v-for="(field, index) in matchFields" :key="index">
            <SearchSelect
              :label="field.caption"
              :options="colHeaders"
              :multiple="false"
              :placeholder="'Select Excel Fields'"
              v-model="field.mapped"
            />
          </div>
        </div>
      </div>
      <div v-if="dbData.length > 0">
        Total {{ dbData.length }} records,
        <span
          >{{
            dbData.filter((record) => getBgColor(record) != "").length
          }}
          Invalid Records</span
        >
        <table
          class="divide-y divide-gray-200 dark:divide-gray-700"
          id="table-records"
        >
          <thead>
            <tr id="table-headers">
              <th
                class="px-6 py-3 text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider"
              >
                Name
              </th>
              <th
                class="px-6 py-3 text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider"
              >
                Customer Type
              </th>
              <th
                class="px-6 py-3 text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider"
              >
                Mobile
              </th>
              <th
                class="px-6 py-3 text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider"
              >
                TIN
              </th>
              <th
                class="px-6 py-3 text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider"
              >
                Price List
              </th>
              <th
                class="px-6 py-3 text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider"
              >
                Credit Term
              </th>
              <th
                class="px-6 py-3 text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider"
              >
                Credit Limit
              </th>
              <th
                class="px-6 py-3 text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider"
              >
                Receivable Account
              </th>
              <th
                class="px-6 py-3 text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider"
              >
                Payment Type
              </th>
              <th
                class="px-6 py-3 text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider"
              >
                State
              </th>
              <th
                class="px-6 py-3 text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider"
              >
                City
              </th>
            </tr>
          </thead>
          <tbody
            class="bg-white dark:bg-gray-900 divide-y divide-gray-200 dark:divide-gray-700"
          >
            <template v-for="(row) in dbData" :key="index">
              <tr
                class="hover:bg-gray dark:hover:bg-gray-700"
                :style="'background-color: ' + getBgColor(row)"
              >
                <td
                  class="px-6 py-4 whitespace-nowrap text-sm text-gray-900 dark:text-white"
                >
                <IconComponent name="CircleCheckBig" class="text-green-500 mr-2" v-if="row.import"/>
                    <IconComponent name="CircleX" class="text-red-500 mr-2" v-if="!row.import"/>
                  {{ row.name }}
                </td>
                <td class="px-6 py-4 text-sm text-gray-900 dark:text-white">
                  <span>{{ row.customer_type }}</span>
                  <SearchSelect
                    v-if="row.customer_types_id === ''"
                    label=""
                    :remote="true"
                    palceholder="Select Customer"
                    end-point="revenue/master-data/customer-types"
                    @select="
                      (item) => {
                        row.customer_types_id = item.id;
                        row.customer_type = item.name;
                      }
                    "
                    v-model="row.customer_types_id"
                  />
                </td>
                <td
                  class="px-6 py-4 whitespace-nowrap text-sm text-gray-900 dark:text-white"
                >
                  {{ row.mobile }}
                </td>
                <td
                  class="px-6 py-4 whitespace-nowrap text-sm text-gray-900 dark:text-white"
                >
                  {{ row.tax_identification_no }}
                </td>
                <td class="px-6 py-4 text-sm text-gray-900 dark:text-white">
                  <span>{{ row.price_list }}</span>
                  <SearchSelect
                    v-if="row.price_lists_id === ''"
                    label=""
                    placeholder="Select Price List"
                    @select="
                      (item) => {
                        row.price_lists_id = item.id;
                        row.price_list = item.name;
                      }
                    "
                    end-point="finance/master-data/price-lists"
                    v-model="row.price_lists_id"
                  />
                </td>
                <td class="px-6 py-4 text-sm text-gray-900 dark:text-white">
                  <span>{{ row.credit_term }}</span>
                  <SearchSelect
                   v-if="row.credit_terms_id === ''"
                    label=""
                    @select="
                      (item) => {
                        row.credit_terms_id = item.id;
                        row.credit_term = item.name;
                      }
                    "
                    placeholder="Select Credit Term"
                    end-point="finance/master-data/credit-terms"
                    v-model="row.credit_terms_id"
                  />
                </td>
                <td
                  class="px-6 py-4 whitespace-nowrap text-sm text-gray-900 dark:text-white"
                >
                  {{ row.credit_limit }}
                </td>
                <td class="px-6 py-4 text-sm text-gray-900 dark:text-white">
                  <span>{{ row.receivable_account }}</span>
                  <SearchSelect
                    v-if="row.chart_of_accounts_id === ''"
                    label=""
                    placeholder="Select Chart of Accounts"
                    @select="
                      (item) => {
                        row.chart_of_accounts_id = item.id;
                        row.receivable_account = item.name;
                      }
                    "
                    end-point="finance/accounting/chart-of-accounts"
                    v-model="row.chart_of_accounts_id"
                  />
                </td>
                <td class="px-6 py-4 text-sm text-gray-900 dark:text-white">
                  <span>{{ row.payment_type }}</span>
                  <SearchSelect
                    v-if="row.payment_types_id === ''"
                    label=""
                    placeholder="Select Payment Type"
                    @select="
                      (item) => {
                        row.payment_types_id = item.id;
                        row.payment_type = item.name;
                      }
                    "
                    end-point="finance/master-data/payment-types"
                    v-model="row.payment_types_id"
                  />
                </td>
                <td class="px-6 py-4 text-sm text-gray-900 dark:text-white">
                  <span>{{ row.state }}</span>
                  <SearchSelect
                    v-if="row.states_id === ''"
                    label=""
                    placeholder="Select State"
                    :remote="true"
                    @select="
                      (item) => {
                        row.states_id = item.id;
                        row.state = item.name;
                      }
                    "
                    end-point="system/master-data/states"
                    v-model="row.states_id"
                  />
                </td>
                <td class="px-6 py-4 text-sm text-gray-900 dark:text-white">
                  <span>{{ row.city }}</span>
                  <SearchSelect
                    v-if="row.citys_id === ''"
                    label=""
                    placeholder="Select City"
                    :remote="true"
                    @select="
                      (item) => {
                        row.citys_id = item.id;
                        row.city = item.name;
                      }
                    "
                    end-point="system/master-data/citys"
                    v-model="row.citys_id"
                  />
                </td>
              </tr>
            </template>
          </tbody>
        </table>
      </div>
      <div v-else>
        <table
          class="divide-y divide-gray-200 dark:divide-gray-700"
          id="table-records"
        >
          <thead>
            <tr id="table-headers">
              <th
                class="px-6 py-3 text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider"
                v-for="h in colHeaders"
              >
                {{ h.name }}
              </th>
            </tr>
          </thead>
          <tbody
            class="bg-white dark:bg-gray-900 divide-y divide-gray-200 dark:divide-gray-700"
          >
            <template v-for="row in excelData">
              <tr class="hover:bg-gray dark:hover:bg-gray-700">
                <td
                  class="px-6 py-4 whitespace-nowrap text-sm text-gray-900 dark:text-white"
                  v-for="(cell, cellIndex) in row"
                  :key="cellIndex"
                >
                  {{ cell }}
                </td>
              </tr>
            </template>
          </tbody>
        </table>
      </div>
    </template>

    <!-- Footer -->
    <template #footer>
      <DocumentFooter
        :readonly="true"
        end-point="endPoint"
        :permissions="[]"
        title="Import Customers using Excel Files"
        @close="$emit('close')"
        :show-new-icon="false"
        :show-share-icons="false"
        :show-save-icon="false"
      />
    </template>
  </ModalFormComponent>
</template>
